import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import {
  Ban,
  ClipboardList,
  CreditCard,
  FileText,
  History,
  LayoutDashboard,
  Monitor,
  PanelLeft,
  Store,
  Tags,
  Users,
  Wallet,
  ArrowLeftRight,
  Receipt,
  UserCheck,
  UserLock,
  FileUser,
  ArrowDownLeft,
  SquareArrowLeft,
  ArrowRightFromLine,
  ShoppingBag,
  Building2,
  Cpu,
  Shield,
} from "lucide-react";
import { jwtDecode } from "jwt-decode";
import { adminServices } from "../services/AdminServices";
const Sidebar = () => {
  const [isActive, setIsActive] = useState(false);
  const [role, setRole] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [selected, setSelected] = useState(window.location.href.split('/').pop());
  const [pages,setPages] = useState([]);
  const handleToggle = () => {
    setIsActive(false);
  };

  useEffect(()=>{
      var token = localStorage.getItem("appToken");
      const r = jwtDecode(token)["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
      setRole(r);
      setIsAdmin(jwtDecode(token)["isAdmin"] === "1");

      getRolePages(r);

      localStorage.setItem("currentRole", r);
  },[]);

  const getRolePages = async (r)=>{

    await adminServices.storeProcedure2("getRolePages",{"role_id": r}).then(response => {
        let pageIds = response.data.map(item => item.pageId);
        setPages(pageIds);
        localStorage.setItem("pages", JSON.stringify(pageIds));
    })
  }

  return (
    <div className={`sidebar ${isActive ? "active" : ""}`}>
      
      <div className="logo-placeholder l t-offwhite">
        {/* <img
          src={require("../tmpImage/logoplaceholder.jpg")}
          style={{ width: "50px", borderRadius: "100px", flex: 1 }}
        /> */}
        {/* <Link to="/" className="link black">
          Admin Booth
        </Link> */}
      </div>
      <div className="line"></div>

      {pages && pages.includes(1) &&  <Link to="/dashboard" className={`sidebarItem ${selected === 'dashboard'? 'activated' : ''}`} onClick={()=>{ setSelected("dashboard"); handleToggle()  }}>
        <LayoutDashboard className="icon t-darkgray" />
        <p className="link r medium">Dashboard</p>
      </Link>}

      {pages && pages.includes(26) &&  <Link to="/accountability-report" className={`sidebarItem ${selected === 'accountability'? 'activated' : ''}`} onClick={()=>{ setSelected("accountability"); handleToggle()  }}>
        <ClipboardList className="icon t-darkgray" />
        <p className="link r medium">Daily Accountability Report</p>
      </Link>}

      {pages && pages.includes(2) && <Link to="/pdl-management" className={`sidebarItem ${selected === 'pdl-management' ? 'activated' : ''}`} onClick={()=>{ setSelected("pdl-management"); handleToggle()  }}>
        <UserLock className="icon t-darkgray" />
        <p className="link r medium">PDL Management</p>
      </Link>}

      {pages && pages.includes(24) && <Link to="/cashout-requests" className={`sidebarItem ${selected === 'cashout-requests' ? 'activated' : ''}`} onClick={()=>{ setSelected("cashout-requests"); handleToggle()  }}>
        <History className="icon t-darkgray" />
        <p className="link r medium">PDL Cash Out Requests</p>
      </Link>}

      {pages && pages.includes(4) && <Link to="/padala-reports" className={`sidebarItem ${selected === 'padala-reports' ? 'activated' : ''}`} onClick={()=>{ setSelected("padala-reports"); handleToggle()  }}>
        <FileUser className="icon t-darkgray" />
        <p className="link r medium">Padala Reports</p>
      </Link>}
      
      {pages && pages.includes(42) && <Link to="/bucor-module" className={`sidebarItem ${selected === 'bucor-module' ? 'activated' : ''}`} onClick={()=>{ setSelected("bucor-module"); handleToggle()  }}>
        <Building2 className="icon t-darkgray" />
        <p className="link r medium">Bucor Module</p>
      </Link>}

      {pages && pages.includes(37) && <Link to="/node-sync" className={`sidebarItem ${selected === 'node-sync' ? 'activated' : ''}`} onClick={()=>{ setSelected("node-sync"); handleToggle()  }}>
        <Cpu className="icon t-darkgray" />
        <p className="link r medium">Node Synchronization</p>
      </Link>}

      {pages && pages.includes(40) && <Link to="/dlt-correction" className={`sidebarItem ${selected === 'dlt-correction' ? 'activated' : ''}`} onClick={()=>{ setSelected("dlt-correction"); handleToggle()  }}>
        <Shield className="icon t-darkgray" />
        <p className="link r medium">DLT Correction</p>
      </Link>}
      
      {/* <div className="line"></div> */}
      {pages && pages.includes(5) &&  <Link to="/kiosk-reports" className={`sidebarItem ${selected === 'kiosk-reports' ? 'activated' : ''}`} onClick={()=>{ setSelected("kiosk-reports"); handleToggle()  }}>
        <Receipt className="icon t-darkgray" />
        <p className="link r medium">Kiosk Sales Report</p>
      </Link>}

      { pages && pages.includes(6) &&  <Link to="/void-transactions" className={`sidebarItem ${selected === 'void-transactions' ? 'activated' : ''}`} onClick={()=>{ setSelected("void-transactions"); handleToggle()  }}>
        <Ban className="icon t-darkgray" />
        <p className="link r medium">Void Transactions</p>
      </Link>}

      {pages && pages.includes(7) &&  <Link to="/floating-padala-reports" className={`sidebarItem ${selected === 'floating-padala-reports' ? 'activated' : ''}`} onClick={()=>{ setSelected("floating-padala-reports"); handleToggle()  }}>
        <FileText className="icon t-darkgray" />
        <p className="link r medium">Floating Padala Report</p>
      </Link>}

      

      {pages && pages.includes(9) &&  <Link to="/load-money" className={`sidebarItem ${selected === 'load-money' ? 'activated' : ''}`} onClick={()=>{ setSelected("load-money"); handleToggle()  }}>
        <Wallet className="icon t-darkgray" />
        <p className="link r medium">Load Money</p>
      </Link>}
     
      
      {/* <Link to="/load-merchant" className={`sidebarItem ${selected === 'pdl-management' ? 'activated' : ''}`} onClick={()=>{ setSelected("pdl-management")  }}>
        <LoadIcon className="icon t-darkgray" />
        <p className="link r medium">Load Money</p>
      </Link> */}
      {pages && pages.includes(13) &&   <Link to="/merchant" className={`sidebarItem ${selected === 'merchant' ? 'activated' : ''}`} onClick={()=>{ setSelected("merchant"); handleToggle()  }}>
        <Store className="icon t-darkgray" />
        <p className="link r medium">Merchants</p>
      </Link>}

      {pages && pages.includes(27) &&   <Link to="/categories" className={`sidebarItem ${selected === 'categories' ? 'activated' : ''}`} onClick={()=>{ setSelected("categories"); handleToggle()  }}>
        <Tags className="icon t-darkgray" />
        <p className="link r medium">Categories</p>
      </Link>}

      {pages && pages.includes(41) &&  <Link to="/orders-inventory" className={`sidebarItem ${selected === 'orders-inventory' ? 'activated' : ''}`} onClick={()=>{ setSelected("orders-inventory"); handleToggle()  }}>
        <ShoppingBag className="icon t-darkgray" />
        <p className="link r medium">Orders and Inventory</p>
      </Link>}

      {pages && pages.includes(16) &&   <Link to="/merchant-padala-reports" className={`sidebarItem ${selected === 'merchant-padala' ? 'activated' : ''}`} onClick={()=>{ setSelected("merchant-padala"); handleToggle()  }}>
        <ArrowDownLeft className="icon t-darkgray" />
        <p className="link r medium">Merchant Padala Report</p>
      </Link>}

      {pages && pages.includes(34) &&   <Link to="/fund-transfer-report" className={`sidebarItem ${selected === 'fund-transfer-report' ? 'activated' : ''}`} onClick={()=>{ setSelected("fund-transfer-report"); handleToggle()  }}>
        <ArrowRightFromLine className="icon t-darkgray" />
        <p className="link r medium">Fund Transfer Report</p>
      </Link>}

      {pages && pages.includes(17) &&   <Link to="/pos-sales-reports" className={`sidebarItem ${selected === 'pos-sales-reports' ? 'activated' : ''}`} onClick={()=>{ setSelected("pos-sales-reports"); handleToggle()  }}>
        <CreditCard className="icon t-darkgray" />
        <p className="link m medium">POS Sales Report</p>
      </Link>}

      {pages && pages.includes(18) &&   <Link to="/icarus-web" className={`sidebarItem ${selected === 'icarus-web' ? 'activated' : ''}`} onClick={()=>{ setSelected("icarus-web"); handleToggle()  }}>
        <ArrowLeftRight className="icon t-darkgray" />
        <p className="link r medium">Icarus Web App</p>
      </Link>}

      {pages && pages.includes(31) &&   <Link to="/icarus-accounts" className={`sidebarItem ${selected === 'icarus-accounts' ? 'activated' : ''}`} onClick={()=>{ setSelected("icarus-accounts"); handleToggle()  }}>
        <Users className="icon t-darkgray" />
        <p className="link r medium">Icarus Accounts</p>
      </Link>}

      

      {pages && pages.includes(29) &&   <Link to="/ecpay" className={`sidebarItem ${selected === 'ecpay' ? 'activated' : ''}`} onClick={()=>{ setSelected("ecpay"); handleToggle()  }}>
        <FileText className="icon t-darkgray" />
        <p className="link r medium">ECPay Transactions</p>
      </Link>}

      {(isAdmin) &&   <Link to="/users-page" className={`sidebarItem ${selected === 'users-page' ? 'activated' : ''}`} onClick={()=>{ setSelected("users-page"); handleToggle()  }}>
        <UserCheck className="icon t-darkgray" />
        <p className="link m medium">Users</p>
      </Link>}     
      {/* <NavLink
        to="/merchant"
        className={`sidebarItem ${selected === 'pdl-management' ? 'activated' : ''}`} onClick={()=>{ setSelected("pdl-management")  }}
        activeClassName="sidebarItemActive"
      >
        <MerchantIcon className="icon t-darkgray" />
        <p className="link r medium">Merchants</p>
      </NavLink> */}
      <div className="spacer"></div>
      <div className="line"></div>
      {pages && pages.includes(19) &&   <Link to="/kiosk-status-reports" className={`sidebarItem ${selected === 'kiosk-status-reports' ? 'activated' : ''}`} onClick={()=>{ setSelected("kiosk-status-reports"); handleToggle()  }}>
        <Monitor className="icon t-darkgray" />
        <p className="link m medium">Kiosk Status Report</p>
      </Link>}

      {pages && pages.includes(22) &&   <Link to="/pos-status-reports" className={`sidebarItem ${selected === 'pos-status-reports' ? 'activated' : ''}`} onClick={()=>{ setSelected("pos-status-reports"); handleToggle()  }}>
        <CreditCard className="icon t-darkgray" />
        <p className="link m medium">POS Status Report</p>
      </Link>}
      
      
      {/* <Link to="/support-help" className={`sidebarItem ${selected === 'support-help' ? 'activated' : ''}`} onClick={()=>{ setSelected("support-help")  }}>
        <SupportIcon className="icon t-darkgray" />
        <p className="link m medium">Support</p>
      </Link> */}
      
      <div className={`sidebarItem`} onClick={()=>{ setIsActive(!isActive) }}>
        <PanelLeft className="icon t-darkgray" />
        <div className="spacer link r medium">Collapse Sidebar</div>
      </div>

      {/* <div className={`sidebarItem ${selected === 'pdl-management' ? 'activated' : ''}`} onClick={()=>{ setSelected("pdl-management")  }}>
        <SettingsIcon className="icon t-darkgray" />
        <Link to="/system-settings" className="link r medium">
          System Settings
        </Link>
      </div> */}
      {/* <div className={`sidebarItem ${selected === 'pdl-management' ? 'activated' : ''}`} onClick={()=>{ setSelected("pdl-management")  }}>
        <ProfileIcon className="icon t-darkgray" />
        <Link to="/profile" className="link r medium">
          Profile
        </Link>
      </div>
      <div className={`sidebarItem ${selected === 'pdl-management' ? 'activated' : ''}`} onClick={()=>{ setSelected("pdl-management")  }}>
        <LogOutIcon className="icon t-darkgray" />
        <Link to="/profile" className="link r medium">
          Logout
        </Link>
      </div> */}
    </div>
  );
};

export default Sidebar;
